import script from "./ClientsPanelListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsPanelListItem.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsPanelListItem.vue?vue&type=style&index=0&id=b0e77214&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0e77214"]])

export default __exports__